import React from 'react'
import { observer, inject } from 'mobx-react'

import Title from '../../../generic/Title'
import Cards from '../../../generic/Cards'

const BranchModalList = inject('configCompaniesStore')(observer(props => {
  const { configCompaniesStore } = props
  const { selectedBranches } = configCompaniesStore.state
  const cardsData = selectedBranches.map(data => {
    return {
      content: <Title size={4}>{`${data.id} - ${data.name}`}</Title>,
      items: [
        <a className='card-footer-item' key={1} onClick={() => {
          configCompaniesStore.setEditBranch(data)
          configCompaniesStore.closeBranchModal()
          configCompaniesStore.openEditBranchModal()
        }}>Editar</a>
      ]
    }
  })
  return (
    <Cards cardsData={cardsData} />
  )
}))

export default BranchModalList



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/BranchModalList.js